import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import qs from 'querystringify';
import Spinner from '../../../components/common/Spinner';
import { postIntegrationAmazonMcf } from '../../../store/actions/integrations';
import PageLayout from '../../../components/common/PageLayout';

function SuppliersIntegrationAmazonMcfContainer(props) {
  const { postIntegrationAmazonMcf, params } = props;
  const postedRef = useRef(false);

  useEffect(() => {
    if (!postedRef.current && postIntegrationAmazonMcf && params) {
      postIntegrationAmazonMcf(params);
      postedRef.current = true;
    }
  }, [postIntegrationAmazonMcf, params]);

  return (
    <PageLayout>
      <div style={{ marginTop: '3em', textAlign: 'center' }}>
        <h2>Connecting your Amazon Multi-Channel Fulfillment Account</h2>
        <Spinner size="large" />
      </div>
    </PageLayout>
  );
}

const mapStateToProps = (state, ownProps) => {
  const { location } = ownProps;
  const queryParams = qs.parse(location.search);

  return {
    params: queryParams,
  };
};

const mapDispatchToProps = (dispatch) => ({
  postIntegrationAmazonMcf: (params) => dispatch(postIntegrationAmazonMcf(params, 'supplier')),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuppliersIntegrationAmazonMcfContainer);
